// import React, { useState } from 'react';
// import { Col, Dropdown, DropdownMenu, DropdownToggle, Nav, NavItem, NavLink, Row, TabContent, TabPane } from 'reactstrap';
// import { Link } from 'react-router-dom';
// import classnames from 'classnames';

// //import images
// import avatar2 from "../../assets/images/users/avatar-2.jpg";
// import avatar8 from "../../assets/images/users/avatar-8.jpg";
// import avatar3 from "../../assets/images/users/avatar-3.jpg";
// import avatar6 from "../../assets/images/users/avatar-6.jpg";
// import bell from "../../assets/images/svg/bell.svg";

// //SimpleBar
// import SimpleBar from "simplebar-react";

// const NotificationDropdown = () => {
//     //Dropdown Toggle
//     const [isNotificationDropdown, setIsNotificationDropdown] = useState(false);
//     const toggleNotificationDropdown = () => {
//         setIsNotificationDropdown(!isNotificationDropdown);
//     };

//     //Tab
//     const [activeTab, setActiveTab] = useState('1');
//     const toggleTab = (tab) => {
//         if (activeTab !== tab) {
//             setActiveTab(tab);
//         }
//     };
//     return (
//         <React.Fragment>
//             <Dropdown isOpen={isNotificationDropdown} toggle={toggleNotificationDropdown} className="topbar-head-dropdown ms-1 header-item">
//                 <DropdownToggle type="button" tag="button" className="btn btn-icon btn-topbar btn-ghost-secondary rounded-circle">
//                     <i className='bx bx-bell fs-22'></i>
//                     <span
//                         className="position-absolute topbar-badge fs-10 translate-middle badge rounded-pill bg-danger">3<span
//                             className="visually-hidden">unread messages</span></span>
//                 </DropdownToggle>
//                 <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
//                     <div className="dropdown-head bg-primary bg-pattern rounded-top">
//                         <div className="p-3">
//                             <Row className="align-items-center">
//                                 <Col>
//                                     <h6 className="m-0 fs-16 fw-semibold text-white"> Notifications </h6>
//                                 </Col>
//                                 <div className="col-auto dropdown-tabs">
//                                     <span className="badge badge-soft-light fs-13"> 4 New</span>
//                                 </div>
//                             </Row>
//                         </div>

//                         <div className="px-2 pt-2">
//                             <Nav className="nav-tabs dropdown-tabs nav-tabs-custom">
//                                 <NavItem>
//                                     <NavLink
//                                         href="#"
//                                         className={classnames({ active: activeTab === '1' })}
//                                         onClick={() => { toggleTab('1'); }}
//                                     >
//                                         All (4)
//                                     </NavLink>
//                                 </NavItem>
//                                 <NavItem>
//                                     <NavLink
//                                         href="#"
//                                         className={classnames({ active: activeTab === '2' })}
//                                         onClick={() => { toggleTab('2'); }}
//                                     >
//                                         Messages
//                                     </NavLink>
//                                 </NavItem>
//                                 <NavItem>
//                                     <NavLink
//                                         href="#"
//                                         className={classnames({ active: activeTab === '3' })}
//                                         onClick={() => { toggleTab('3'); }}
//                                     >
//                                         Alerts
//                                     </NavLink>
//                                 </NavItem>
//                             </Nav>
//                         </div>

//                     </div>

//                     <TabContent activeTab={activeTab}>
//                         <TabPane tabId="1" className="py-2 ps-2">
//                             <SimpleBar style={{ maxHeight: "300px" }} className="pe-2">
//                                 <div className="text-reset notification-item d-block dropdown-item position-relative">
//                                     <div className="d-flex">
//                                         <div className="avatar-xs me-3">
//                                             <span className="avatar-title bg-soft-info text-info rounded-circle fs-16">
//                                                 <i className="bx bx-badge-check"></i>
//                                             </span>
//                                         </div>
//                                         <div className="flex-1">
//                                             <Link to="#" className="stretched-link">
//                                                 <h6 className="mt-0 mb-2 lh-base">Your <b>Elite</b> author Graphic
//                                                     Optimization <span className="text-secondary">reward</span> is ready!
//                                                 </h6>
//                                             </Link>
//                                             <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
//                                                 <span><i className="mdi mdi-clock-outline"></i> Just 30 sec ago</span>
//                                             </p>
//                                         </div>
//                                         <div className="px-2 fs-15">
//                                             <div className="form-check notification-check">
//                                                 <input className="form-check-input" type="checkbox" value="" id="all-notification-check01" />
//                                                 <label className="form-check-label" htmlFor="all-notification-check01"></label>
//                                             </div>
//                                             {/* <input className="form-check-input" type="checkbox" /> */}
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="text-reset notification-item d-block dropdown-item position-relative active">
//                                     <div className="d-flex">
//                                         <img src={avatar2}
//                                             className="me-3 rounded-circle avatar-xs" alt="user-pic" />
//                                         <div className="flex-1">
//                                             <Link to="#" className="stretched-link"><h6 className="mt-0 mb-1 fs-13 fw-semibold">Angela Bernier</h6></Link>
//                                             <div className="fs-13 text-muted">
//                                                 <p className="mb-1">Answered to your comment on the cash flow forecast's
//                                                     graph 🔔.</p>
//                                             </div>
//                                             <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
//                                                 <span><i className="mdi mdi-clock-outline"></i> 48 min ago</span>
//                                             </p>
//                                         </div>
//                                         <div className="px-2 fs-15">
//                                             <div className="form-check notification-check">
//                                                 <input className="form-check-input" type="checkbox" value="" id="all-notification-check02"/>
//                                                 <label className="form-check-label" htmlFor="all-notification-check02"></label>
//                                             </div>
//                                             {/* <input className="form-check-input" type="checkbox" /> */}
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="text-reset notification-item d-block dropdown-item position-relative">
//                                     <div className="d-flex">
//                                         <div className="avatar-xs me-3">
//                                             <span
//                                                 className="avatar-title bg-soft-danger text-danger rounded-circle fs-16">
//                                                 <i className='bx bx-message-square-dots'></i>
//                                             </span>
//                                         </div>
//                                         <div className="flex-1">
//                                             <Link to="#" className="stretched-link">
//                                                 <h6 className="mt-0 mb-2 fs-13 lh-base">You have received <b className="text-success">20</b> new messages in the conversation</h6>
//                                             </Link>
//                                             <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
//                                                 <span><i className="mdi mdi-clock-outline"></i> 2 hrs ago</span>
//                                             </p>
//                                         </div>
//                                         <div className="px-2 fs-15">
//                                             <div className="form-check notification-check">
//                                                 <input className="form-check-input" type="checkbox" value="" id="all-notification-check03" />
//                                                 <label className="form-check-label" htmlFor="all-notification-check03"></label>
//                                             </div>
//                                             {/* <input className="form-check-input" type="checkbox" /> */}
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="text-reset notification-item d-block dropdown-item position-relative">
//                                     <div className="d-flex">
//                                         <img src={avatar8} className="me-3 rounded-circle avatar-xs" alt="user-pic" />
//                                         <div className="flex-1">
//                                             <Link to="#" className="stretched-link"><h6 className="mt-0 mb-1 fs-13 fw-semibold">Maureen Gibson</h6></Link>
//                                             <div className="fs-13 text-muted">
//                                                 <p className="mb-1">We talked about a project on linkedin.</p>
//                                             </div>
//                                             <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
//                                                 <span><i className="mdi mdi-clock-outline"></i> 4 hrs ago</span>
//                                             </p>
//                                         </div>
//                                         <div className="px-2 fs-15">
//                                             <div className="form-check notification-check">
//                                                 <input className="form-check-input" type="checkbox" value="" id="all-notification-check04" />
//                                                 <label className="form-check-label" htmlFor="all-notification-check04"></label>
//                                             </div>
//                                             {/* <input className="form-check-input" type="checkbox" /> */}
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="my-3 text-center">
//                                     <button type="button" className="btn btn-soft-success waves-effect waves-light">View
//                                         All Notifications <i className="ri-arrow-right-line align-middle"></i></button>
//                                 </div>
//                             </SimpleBar>

//                         </TabPane>

//                         <TabPane tabId="2" className="py-2 ps-2">
//                             <SimpleBar style={{ maxHeight: "300px" }} className="pe-2">
//                                 <div className="text-reset notification-item d-block dropdown-item">
//                                     <div className="d-flex">
//                                         <img src={avatar3}
//                                             className="me-3 rounded-circle avatar-xs" alt="user-pic" />
//                                         <div className="flex-1">
//                                             <Link to="#" className="stretched-link"><h6 className="mt-0 mb-1 fs-13 fw-semibold">James Lemire</h6></Link>
//                                             <div className="fs-13 text-muted">
//                                                 <p className="mb-1">We talked about a project on linkedin.</p>
//                                             </div>
//                                             <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
//                                                 <span><i className="mdi mdi-clock-outline"></i> 30 min ago</span>
//                                             </p>
//                                         </div>
//                                         <div className="px-2 fs-15">
//                                         <div className="form-check notification-check">
//                                                     <input className="form-check-input" type="checkbox" value="" id="messages-notification-check01" />
//                                                     <label className="form-check-label" htmlFor="messages-notification-check01"></label>
//                                                 </div>
//                                             {/* <input className="form-check-input" type="checkbox" /> */}
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="text-reset notification-item d-block dropdown-item">
//                                     <div className="d-flex">
//                                         <img src={avatar2}
//                                             className="me-3 rounded-circle avatar-xs" alt="user-pic" />
//                                         <div className="flex-1">
//                                             <Link to="#" className="stretched-link"><h6 className="mt-0 mb-1 fs-13 fw-semibold">Angela Bernier</h6></Link>
//                                             <div className="fs-13 text-muted">
//                                                 <p className="mb-1">Answered to your comment on the cash flow forecast's
//                                                     graph 🔔.</p>
//                                             </div>
//                                             <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
//                                                 <span><i className="mdi mdi-clock-outline"></i> 2 hrs ago</span>
//                                             </p>
//                                         </div>
//                                         <div className="px-2 fs-15">
//                                         <div className="form-check notification-check">
//                                                     <input className="form-check-input" type="checkbox" value="" id="messages-notification-check02" />
//                                                     <label className="form-check-label" htmlFor="messages-notification-check02"></label>
//                                                 </div>
//                                             {/* <input className="form-check-input" type="checkbox" /> */}
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="text-reset notification-item d-block dropdown-item">
//                                     <div className="d-flex">
//                                         <img src={avatar6}
//                                             className="me-3 rounded-circle avatar-xs" alt="user-pic" />
//                                         <div className="flex-1">
//                                             <Link to="#" className="stretched-link"><h6 className="mt-0 mb-1 fs-13 fw-semibold">Kenneth Brown</h6></Link>
//                                             <div className="fs-13 text-muted">
//                                                 <p className="mb-1">Mentionned you in his comment on 📃 invoice #12501. </p>
//                                             </div>
//                                             <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
//                                                 <span><i className="mdi mdi-clock-outline"></i> 10 hrs ago</span>
//                                             </p>
//                                         </div>
//                                         <div className="px-2 fs-15">
//                                         <div className="form-check notification-check">
//                                                     <input className="form-check-input" type="checkbox" value="" id="messages-notification-check03" />
//                                                     <label className="form-check-label" htmlFor="messages-notification-check03"></label>
//                                                 </div>
//                                             {/* <input className="form-check-input" type="checkbox" /> */}
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="text-reset notification-item d-block dropdown-item">
//                                     <div className="d-flex">
//                                         <img src={avatar8}
//                                             className="me-3 rounded-circle avatar-xs" alt="user-pic" />
//                                         <div className="flex-1">
//                                             <Link to="#" className="stretched-link"><h6 className="mt-0 mb-1 fs-13 fw-semibold">Maureen Gibson</h6></Link>
//                                             <div className="fs-13 text-muted">
//                                                 <p className="mb-1">We talked about a project on linkedin.</p>
//                                             </div>
//                                             <p className="mb-0 fs-11 fw-medium text-uppercase text-muted">
//                                                 <span><i className="mdi mdi-clock-outline"></i> 3 days ago</span>
//                                             </p>
//                                         </div>
//                                         <div className="px-2 fs-15">
//                                         <div className="form-check notification-check">
//                                                     <input className="form-check-input" type="checkbox" value="" id="messages-notification-check04" />
//                                                     <label className="form-check-label" htmlFor="messages-notification-check04"></label>
//                                                 </div>
//                                             {/* <input className="form-check-input" type="checkbox" /> */}
//                                         </div>
//                                     </div>
//                                 </div>

//                                 <div className="my-3 text-center">
//                                     <button type="button" className="btn btn-soft-success waves-effect waves-light">View
//                                         All Messages <i className="ri-arrow-right-line align-middle"></i></button>
//                                 </div>
//                             </SimpleBar>
//                         </TabPane>
//                         <TabPane tabId="3" className="p-4">
//                             <div className="w-25 w-sm-50 pt-3 mx-auto">
//                                 <img src={bell} className="img-fluid" alt="user-pic" />
//                             </div>
//                             <div className="text-center pb-5 mt-2">
//                                 <h6 className="fs-18 fw-semibold lh-base">Hey! You have no any notifications </h6>
//                             </div>
//                         </TabPane>
//                     </TabContent>
//                 </DropdownMenu>
//             </Dropdown>
//         </React.Fragment>
//     );
// };

// export default NotificationDropdown;

import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Dropdown, DropdownToggle, DropdownMenu, Row, Col, Input } from 'reactstrap';
import SimpleBar from 'simplebar-react';
import { toast } from 'react-toastify';
import { withTranslation } from 'react-i18next';
import { useSelector, useDispatch } from "react-redux";
import moment from "moment";
import { CircularProgress } from '@mui/material';
import ReactQuill from 'react-quill';
import NoDataFound from './NoDataFound';
import Ticket from "../../../src/assets/images/icons/ticket.png";
import useChannel from '../../utils/pusher/hooks';
import { getAllNotificationList, getAllUnreadNotificationCount, markAllReadNotification, markAsReadNotification } from '../../api/casp/notification';
import { DefaultPerPageValue, NotificationEvent } from '../../constants/Common';
import axios from 'axios';
import { projectUserSuccess } from '../../store/projectUser/actions';
import { setCurrentProjectRole } from '../../store/roles';
import { Role } from '../../constants/Role';
import { Modules } from '../../constants/Module';
import { ucFirstLetter } from '../../helpers/string_helper';
import { useTranslation } from 'react-i18next';

const Notification = ({ subject, body }) => {
    return (
        <div className="notification">
            <div className="notification-icon">
                <i className="fas fa-bell"></i>
            </div>
            <div className="notification-content">
                <h3 className="notification-subject">{subject}</h3>
                <p className="notification-body">
                    <ReactQuill
                        value={body?.replace(/(<([^>]+)>)/gi, "")}
                        readOnly={true}
                        theme={'bubble'}
                    />
                </p>
            </div>
        </div>
    );
};

const NotificationDropdown = (props) => {
    const { t } = useTranslation();
    const [menu, setMenu] = useState(false);
    const [isMounted, setMounted] = useState(true);
    const params = useParams()
    const navigate = useNavigate();
    const dispatch = useDispatch()
    const loggedInUser = useSelector((state) => state.Profile.user);
        const [currentPage, setCurrentPage] = useState(1);
    const [paginationMeta, setPaginationMeta] = useState(null);
    const [readAllState, setReadAllState] = useState(false)
    const [loading, setLoading] = useState(false);
    const observer = useRef();
    const prevProps = useRef({});
    const lastNotificationRef = useRef(null)

    useEffect(() => {
        const handleIntersection = (entries) => {
            const target = entries[0];
            if (target.isIntersecting && !loading) {
                fetchNotificationList();
            }
        };

        observer.current = new IntersectionObserver(handleIntersection, {
            root: null,
            rootMargin: '0px',
            threshold: 0.1,
        });

        if (lastNotificationRef.current && paginationMeta.next) {
            observer.current.observe(lastNotificationRef.current);
        }

        return () => {
            if (observer.current) {
                observer.current.disconnect();
            }
        };
    }, [currentPage]);

    const callPusher = (data) => {
        if (data) {
            fetchUnreadNotificationCount()
            toast(<Notification subject={data.subject} body={data.body} />, {
                position: 'top-center'
            })
        }
    }

    Object.values(NotificationEvent).forEach((event) => {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        useChannel(null, event, callPusher)
    })

    useEffect(() => {
        if (isMounted && !readAllState) {
            fetchUnreadNotificationCount();
            callPusher();
        } else if(!readAllState) {
            props.refreshNotification()
        }
    }, [props])

    const [unreadNotificationCount, setUnreadNotificationCount] = useState(0)
    const fetchUnreadNotificationCount = async () => {
        try {
            const res = await getAllUnreadNotificationCount()
            setUnreadNotificationCount(res.data.data)
            setMounted(false);
        } catch (e) {
            console.error(e)
        }
    }

    const [notificationList, setNotificationList] = useState([])
    const fetchNotificationList = async () => {
        try {
            setLoading(true);
            const res = await getAllNotificationList({page: currentPage, perPage: DefaultPerPageValue})
            setNotificationList([...notificationList, ...res.data.data.data]);
            setCurrentPage(prevPage => prevPage + 1);
            setPaginationMeta(res.data.data.meta)
        } catch (e) {
            console.error(e)
        } finally {
            setLoading(false);
        }
    }

    const fetchBodyData = (body) => {
        const eventType = body.module === 'changeRequest' ? body.event?.split('-')?.[3] : body.event?.split('-')?.[2]
        const approvalType = ucFirstLetter(body.event?.split('-')?.[1])
        switch (body?.event) {
            case NotificationEvent.PROJECT_APPROVAL_REQUESTED:
            case NotificationEvent.PROJECT_SUBMISSION_REQUESTED:
                return `<b>${body?.projectDetails?.name} (${body?.projectDetails?.uniqueProjectId})</b> Project is waiting for your ${approvalType === 'Approval' ? '' : approvalType} Approval.`

            case NotificationEvent.PROJECT_APPROVAL_REJECTED:
            case NotificationEvent.PROJECT_APPROVAL_APPROVED:
            case NotificationEvent.PROJECT_SUBMISSION_APPROVED:
            case NotificationEvent.PROJECT_SUBMISSION_REJECTED:
                return `The Project ${approvalType === 'Approval' ? '' : approvalType} Approval of <b>${body?.projectDetails?.name} (${body?.projectDetails?.uniqueProjectId})</b>
                 Project is ${ucFirstLetter(eventType)} by <b> (${body?.user?.role}) ${body?.user?.name} (${body?.user?.uniqueId})</b>`

            case NotificationEvent.MILESTONE_SUBMISSION_REJECTED:
            case NotificationEvent.MILESTONE_SUBMISSION_APPROVED:
            case NotificationEvent.DELIVERABLE_SUBMISSION_APPROVED:
            case NotificationEvent.DELIVERABLE_SUBMISSION_REJECTED:
            case NotificationEvent.CHANGE_REQUEST_APPROVAL_APPROVED:
            case NotificationEvent.CHANGE_REQUEST_APPROVAL_REJECTED:
                return `The ${body.module !== 'changeRequest' ? `${ucFirstLetter(body.module)} Submission <b>(${body?.moduleRelation?.name})` : `<b>Change Request (${body?.moduleRelation?.uniqueChangeRequestId})</b>`}</b> of Project
                <b>${body?.projectDetails?.name} (${body?.projectDetails?.uniqueProjectId})</b> is ${ucFirstLetter(eventType)} by <b> (${body?.user?.role}) ${body?.user?.name} (${body?.user?.uniqueId})</b>`

            case NotificationEvent.MILESTONE_SUBMISSION_REQUESTED:
            case NotificationEvent.DELIVERABLE_SUBMISSION_REQUESTED:
            case NotificationEvent.CHANGE_REQUEST_APPROVAL_REQUESTED:
                return `${body.module !== 'changeRequest' ? `${ucFirstLetter(body.module)} Submission <b>(${body?.moduleRelation?.name})` : `<b>Change Request (${body?.moduleRelation?.uniqueChangeRequestId})</b>`}</b> of Project <b>${body?.projectDetails?.name} (${body?.projectDetails?.uniqueProjectId})</b> is waiting for your ${body.module !== 'changeRequest' ? 'Submission' : ''} Approval`

            case NotificationEvent.PROJECT_ANNOUNCEMENT:
                return `<p style="font-weight: 400px;">
                There is a new announcement for <b>${body?.projectDetails?.name}</b>. Please go through it:
                <strong>${body?.message?.length > 50 ? `${body?.message?.slice(0, 50)}...` : body?.message}</strong>
                </p>`

            case NotificationEvent.TASK_ASSIGNED:
                return `You are assigned task <b>(${body?.moduleRelation?.name})</b> of Project <strong>${body?.projectDetails?.name}</strong>, click here to check`
                case NotificationEvent.WORKSHOP:
                    if(body?.moduleRelation?.action === 'create'){
                        return body?.moduleRelation?.type === 'Workshop'?
                            `Workshop <b>(${body?.moduleRelation?.name})</b> has been created, click here to check`:
                            `Event <b>(${body?.moduleRelation?.name})</b> has been created, click here to check`
                    }
                    else{
                        return body?.moduleRelation?.type === 'Workshop'?
                        `Workshop <b>(${body?.moduleRelation?.name})</b> has been updated, click here to check`:
                        `Event <b>(${body?.moduleRelation?.name})</b> has been updated, click here to check` 
                    }
            default:
                return
        }

    }

    useEffect(() => {
        if (menu) {
            fetchNotificationList()
            fetchUnreadNotificationCount()
        }
    }, [menu])

    const fetchMarkAsReadNotification = async (allRead = false, ids, isRead) => {
        try {
            if(!isRead && allRead) {
                setReadAllState(true)
                await markAllReadNotification()
                // props.refreshNotification()
                await fetchUnreadNotificationCount()
            }
            else if (!isRead) {
                const ids = notificationList?.map((item) => item?.id)
                await markAsReadNotification({ ids })
                await fetchUnreadNotificationCount()
            }
            setReadAllState(false)
            setMenu(!menu)
            toast.success(t(`${allRead === true ? 'All' : ''} Notification(s) marked as read successfully.`))
        } catch (e) {
            toast.error(t('Something went wrong.'))
        }
    }

     const setProjectUser = async (projectId) => {
        let role = ''
        await axios.get(`project-user/${parseInt(projectId)}`).then((response) => {
            role = response.data.data.role.name
            dispatch(projectUserSuccess(response.data))
            dispatch(setCurrentProjectRole({ role: response.data.data.role.name, project: response.data.data.project }))
        }).catch((err) => {
            console.error(err)
        })
        return role
    }

    return (
        <Dropdown
            isOpen={menu}
            toggle={() => {
                setMenu(!menu)
                setNotificationList([]);
                setCurrentPage(1);
                setPaginationMeta(null)
            }}
            className="dropdown d-inline-block"
            tag="li"
        >
            <DropdownToggle
                className="btn header-item noti-icon waves-effect"
                tag="button"
                id="page-header-notifications-dropdown"
            >
                <i className="bx bx-bell fs-22" />
                {unreadNotificationCount > 0 ? (<span className="badge badge_shape bg-danger rounded-pill">{unreadNotificationCount}</span>) : null}
            </DropdownToggle>

            <DropdownMenu className="dropdown-menu-lg dropdown-menu-end p-0">
                <div className="p-3">
                    <Row className="align-items-center">
                        <Col>
                            <div className='d-flex'>
                                <h6 className="mx-1 font-size-16">
                                    {props.t('Notifications')}
                                </h6>
                            </div>
                        </Col>
                        {notificationList?.length > 0 && unreadNotificationCount > 0 &&
                            <div className="col-auto">
                                <Link className="small" onClick={() => fetchMarkAsReadNotification(true)}>
                                    Mark all as read
                                </Link>
                            </div>
                        }
                    </Row>
                </div>

                <SimpleBar style={{ 'maxHeight': '300px' }} >
                    {notificationList.length > 0 && notificationList.map((notification, index) => {
                        return (
                            <div
                                onClick={async () => {
                                    const body = notification?.notification?.content?.body

                                    if(body.event === NotificationEvent.WORKSHOP){
                                        navigate('/calendar')
                                        if (notification.is_read === false) {
                                            markAsReadNotification({ ids: [notification.id] })
                                        }
                                        return
                                    }
                                     let role
                                    if (!params.project || !params.projectId) {
                                        role = await setProjectUser(parseInt(body?.projectId))
                                    }

                                    if (notification.is_read === false) {
                                        markAsReadNotification({ ids: [notification.id] })
                                    }

                                    const eventArray = body.event?.split('-')
                                    if (eventArray[eventArray?.length - 1] === 'requested' && role !== Role.PROJECT_MANAGER) {
                                        navigate('/all-actions', {
                                            state: {
                                                moduleRelation: JSON.stringify({ id: body?.approvalId, module: body?.module })
                                            }
                                        })
                                    } else {
                                        navigate(body?.url)
                                    }
                                    setMenu(false)
                                }}
                                className='text-dark notification-item'
                                style={{ cursor: 'pointer' }}
                                key={index}
                                ref={notificationList.length === index + 1 ? lastNotificationRef : null}
                                state={notification?.notification?.content?.body}
                            >
                                <div className={`d-flex my-1 align-items-start ${!notification?.is_read && 'notification-active'}`}>
                                    <div className="flex-1">
                                        <h6 className="mt-0 mb-1">{notification?.notification?.content?.subject}</h6>
                                        <div className="font-size-12 text-muted">
                                            <ReactQuill className='notification_detail'
                                                value={fetchBodyData(notification?.notification?.content?.body)}
                                                readOnly={true}
                                                theme={'bubble'}
                                            />
                                            <p className="mb-0">
                                                <i className="mdi mdi-clock-outline me-1" />
                                                {moment(notification?.createdAt).fromNow()}
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )
                    })}
                    {notificationList?.length === 0 && loading && (
                        <div style={{ textAlign: 'center' }}>
                            <CircularProgress />
                        </div>
                    )}

                    {notificationList?.length === 0 && !loading && (
                        <div style={{ textAlign: 'center' }}>
                            <NoDataFound text={t('No Notifications to show')} style={{ width: '50px', height: '50px' }} icon={Ticket} />
                        </div>
                    )}
                </SimpleBar>
            </DropdownMenu>
        </Dropdown>
    );
}

export default withTranslation()(NotificationDropdown);
